<template>
    <div class="page checkOutPage">
        <div class="flexContainer">
            <div class="container orderForm">
                <div class="row">
                    <div class="col-12">
                        <div class="title h1 descktopMediaBox">Order Details</div>
                        <div class="title h2 mediaHideOnDesctop">In-store Pickup for</div>
                        <form class="pickupPerson">
                            <div class="formRow">
                                <input type="text" name="fname" placeholder="First Name*" required v-model="tempUser.first_name">
                            </div>
                            <div class="formRow">
                                <input type="text" name="lname" placeholder="Last Name*" required v-model="tempUser.last_name">
                            </div>
                            <div class="formRow">
                                <input type="email" name="email" placeholder="Email Address*" required v-model="tempUser.email">
                            </div>
                            <div class="formRow">
                                <input type="phone" name="phone" placeholder="Phone Number*" required v-model="tempUser.phone">
                            </div>
                            <div class="caption">*Required fields</div>
                            <div class="formBtn d-flex mt-3" v-if="!user">
                                <router-link :to="{name:'Login'}" class="smlBtn zbg mr-2">Log in</router-link>
                                <router-link :to="{name:'Registration'}" class="smlBtn zbg">Join</router-link>
                            </div>
                        </form>
                       
                    </div>
                </div>
                <div class="descktopMediaBox">
                    <RewardSection v-if="user"/>
                </div>
                <div class="totalsSection rewardsBOx descktopMediaBox">
                    <div class="row">
                        <div class="col-12">
                            <h4>Special Instructions</h4>
                            <form>
                                <textarea name="" id="" v-model="cart.comment"></textarea>
                            </form>
                        </div>
                        <div class="totalList col-12">
                            <div class="subtotal">
                                <div class="title caption">
                                    Subtotal:
                                </div>
                                <div class="value">
                                    ${{ cart.subTotal() }}
                                </div>
                            </div>
                            <div class="subtotal" v-if="cart.tax">
                                <div class="title caption">
                                    Tax:
                                </div>
                                <div class="value">
                                    ${{ cart.tax }}
                                </div>
                            </div>
                            <div class="subtotal" v-if="cart.discountTotal()">
                                <div class="title caption">
                                    Applied Reward:
                                </div>
                                <div class="value">
                                    -${{ cart.discountTotal() }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="totalSection">
                                <div class="title h4">
                                    Order Total:
                                </div>
                                <div class="value h5">
                                    ${{ cart.total() }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="botBtn descktopMediaBox">
                    <div class="row">
                        <div class="col-12">
                            <a class="btnlink zbg" @click="checkout()">
                                Complete Order
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="orderDetails">
                <div class="container">
                    <div class="row">
                        <div class="col-12 orderTitle">
                            <h2 class="mediaHideOnDesctop">Order Details</h2>
                            <h2 class="descktopMediaBox">Order Summary</h2>
                        </div>
                        <div class="col-12">
                            <div class="pickTime">
                                <div class="pickup">
                                    <img :src="getStaticImage('icons/checkout/pickup_logo.svg')"/>
                                    <div class="title h5">
                                        Pickup:
                                    </div>
                                    <div class="text caption">
                                        {{ cart.business.fullAddress() }}
                                    </div>
                                </div>
                                <div class="time">
                                    <img :src="getStaticImage('icons/checkout/time.svg')"/>
                                    <div class="title h5 pr-1">
                                        Time:
                                    </div>
                                    <div class="text caption">
                                        {{ this.cart.calcOrderTime() }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="oderListSection">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h2>Your Order</h2>
                                <div class="orderList">
                                    <div class="el" v-for="prod in cart.products">
                                        <div  class="imgBox descktopMediaBox" :style="{backgroundImage: 'url(\''+prod.photo_large+'\')'}"></div>
                                        <div class="title">
                                            <span class="h5">{{ prod.menu_title }} <span>x{{ prod.quantity }}</span></span>
                                            <div class="desc caption">
                                                <span v-for="(m,index,key) in prod.activeModifiers"><span v-if="m.quantity>1">x{{m.quantity}}</span> {{m.title.toLowerCase()}}<span
                                                    v-if="key != Object.keys(prod.activeModifiers).length -1">, </span></span>
                                            </div>
                                        </div>
                                        <div class="quant">
                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="totalsSection rewardsBOx descktopMediaBox">
                    <div class="col-12">
                        <CartPaymentsOption/>
                        <GiftCardsList show-checkout-check-box="1"/>
                    </div>
                </div>
            </div>
            <div class="mediaHideOnDesctop">
                <RewardSection v-if="user"/>
            </div>
            <div class="totalsSection rewardsBOx mob mediaHideOnDesctop">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h4>Special Instructions</h4>
                            <form>
                                <textarea name="" id="" v-model="cart.comment"></textarea>
                            </form>
                        </div>
                        <div class="totalList col-12">
                            <div class="subtotal">
                                <div class="title caption">
                                    Subtotal:
                                </div>
                                <div class="value">
                                    ${{ cart.subTotal() }}
                                </div>
                            </div>
                            <div class="subtotal" v-if="cart.tax">
                                <div class="title caption">
                                    Tax:
                                </div>
                                <div class="value">
                                    ${{ cart.tax }}
                                </div>
                            </div>
                            <div class="subtotal" v-if="cart.discountTotal()">
                                <div class="title caption">
                                    Applied Reward:
                                </div>
                                <div class="value">
                                    -${{ cart.discountTotal() }}
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="totalSection">
                                <div class="title h4">
                                    Order Total:
                                </div>
                                <div class="value h5">
                                    ${{ cart.total() }}
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="totalsSection rewardsBOx mediaHideOnDesctop">
                <div class="container">
                    <div class="row">
                        <div  class="col-12">
                            <CartPaymentsOption/>
                            <GiftCardsList show-checkout-check-box="1"/>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="botBtn mediaHideOnDesctop">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <a class="btnlink zbg" @click="checkout()">
                                Complete Order
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CartPaymentsOption from "../../components/checkout/CartPaymentsOption";
    import RewardSection from "../../components/checkout/RewardSection";
    import GiftCardsList from "../../components/checkout/GiftCardsList";

    export default {
        name: "Checkout",
        components: {GiftCardsList, RewardSection, CartPaymentsOption},
        data() {
            return {
                tempUser: {
                    first_name: null,
                    last_name: null,
                    email: null,
                    phone: null,
                },
                isAvailable: false,
            }
        },
        created() {
            
            if(this.$store.state.cart.tempUser){
                this.tempUser =  this.$store.state.cart.tempUser;
            }
            
            this.$store.dispatch('cart/loadTax',{callback: () => {}});
            
            if (!this.cart.products.length) {
                this.$router.push({name: "Menu"});
            }
            if (this.gatewayInfo.giftcard) {
                this.$store.dispatch("shared/getGatewayInfo");
            }
            this.$store.commit("shared/setTopBar", {
                title: this.cart.business.fullAddress() + "<br/>PickUp " + this.cart.order_time,
                showBackButton: true,
                showBag: true,
                smallText: true
            });
        },
        mounted() {
            if (this.user) {
                //console.log(this.user)
                this.tempUser = {...this.user}
            }
        },
        methods: {
            checkout() {
                
                if (this.user?.member_id && (!this.user.first_name || !this.user.last_name || !this.user.phone || !this.user.email)) {
                    this.$store.commit("shared/setAlert", "<h5>Please finish your profile before proceeding</h5>");
                    this.$router.push({name: "AccountInformation", query: {prev: "OrderSummary"}});
                    return false;
                }

                if (!this.user?.member_id && (!this.tempUser.first_name || !this.tempUser.last_name || !this.tempUser.phone || !this.tempUser.email)) {
                    this.$store.commit("shared/setAlert", "<h5>Please fill the profile form before proceeding</h5>");
                    return false;
                }else{
                    this.$store.commit("cart/setTempUser", this.tempUser);
                }
                
                //#####################################################

                this.tempUser.phone = this.tempUser.phone.replace(/[^0-9]/g, '')
                
                let data = this.cart.generateCartData( this.tempUser );
                
                let url;
                if (!this.user?.member_id) {
                    url = `/unauth/guests/orders`;
                } else {
                    url = `/auth/users/${this.user.member_id}/purchases/orders`
                }
                //#########
                /*console.log(JSON.stringify(data, null, "\t"))
                return false;*/
                
                if(!data.user_payment?.credit_card_id && !data.user_payment?.opaque_data_value){
                    this.$store.commit("shared/setAlert", "<h5>In order to complete your purchase, a valid payment method must be attached to your account. Please enter your credit card information to complete your profile and process your transaction.</h5>");
                    return false;
                }
                
                this.$store.dispatch("cart/proceedOrder", {
                    url,
                    data,
                    callback: (data) => {
                        this.$store.commit("cart/setConfirmationValues", {
                            business: this.cart.business,
                            order_time: this.cart.order_time
                        });
                        if (window.ga) {
                            this.sendToGA();// Sent to Google Analityc
                        }
                        if (window.kbluedot){
                            window.kbluedot.authenticate(() => {
                                        window.kbluedot.setCustomEventMetaData({orderId: data.order_id});
                                    },
                                    (err) => {
                                        console.log("bluedot failed: " +  err);
                                    }, "567e3a84-f3d1-477d-9c2b-5ba76453b5ca");
                        }
                        this.$router.push({name: 'PickupComplete'})
                        setTimeout(() => {
                            //reseting after page changed. to prevent errors
                            this.$store.commit("cart/resetCart");
                            this.$store.commit("shared/setGuestId", null)
                        }, 1000);
                    }
                });
            },
            sendToGA() {
                this.cart.products.map(el => {
                    window.ga.addTransactionItem(el.menu_id, el.menu_title, '', '', parseFloat(el.menu_price), parseInt(el.quantity), 'USD')
                });
                let offers = [];
                if (this.cart.coupon) {
                    this.cart.coupon.map(c => {
                        offers.push(c.offer_title)
                    });
                }
                window.ga.addTransaction(
                        'T' + Date.now(),
                        'Kettleman\'s Bagle APP',
                        parseFloat(this.cart.total()),
                        parseFloat(this.cart.tax),
                        0,
                        'USD');
                window.ga.dispatch();
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart.cart
            },
            gatewayInfo() {
                return this.$store.state.shared.gatewayInfo
            },
        },
        beforeDestroy() {
            if(this.tempUser){
                this.$store.commit("cart/setTempUser", this.tempUser);
            }
        }
    }
</script>
